import axios from 'axios';

export interface FlashNewsData {
  title: string;
  subtitle: string;
  image: string;
  features?: string[];
  cta?: {
    label: string;
    description: string;
  };
}

class FlashNewsService {
  /**
   * Fetch Flash News banner data from JSON
   * You can easily update the JSON file to change banner without redeploying code
   */
  async getFlashNewsData(): Promise<FlashNewsData> {
    try {
      const response = await axios.get('/flash-news.json');
      return response.data;
    } catch (error) {
      console.warn('Failed to load flash-news.json, using default data', error);
      // Return default data if file doesn't exist
      return this.getDefaultFlashNewsData();
    }
  }

  /**
   * Default banner data (fallback)
   */
  private getDefaultFlashNewsData(): FlashNewsData {
    return {
      title: "Sanjeevini",
      subtitle: "Kashaya powder",
      image: "https://farm2me.azurewebsites.net/images/farm2me/Banner.jpg",
    //   features: [
    //     "Supports Diabetic Health",
    //     "Balances BP & Heart Health",
    //     "Improves Digestion & Gut Strength",
    //     "Boosts Immunity Naturally",
    //     "Anti-Inflammatory & Detoxifying",
    //   ],
      cta: {
        label: "Shop Now",
        description: "Begin each day with the designated millet pack on an empty stomach",
      },
    };
  }
}

export default new FlashNewsService();
